const state = {
    tasks: []
}

const mutations = {
    ADD_TASK (state, task) {
        state.tasks = [ ...state.tasks, task ]
    },
    REMOVE_TASK (state, key) {
        state.tasks = state.tasks.filter(task => task.key !== key)
    },
    REMOVE_ALL_TASKS (state) {
        state.tasks = []
    }
}

const actions = {
    async addTaskToLoader (store, payload) {
        store.commit('ADD_TASK', payload)
    },
    async removeTaskFromLoader (store, key) {
        store.commit('REMOVE_TASK', key)
    },
    async clearBlockers (store) {
        store.commit('REMOVE_ALL_TASKS')
    }
}

const getters = {
    tasks: (state) => state.tasks,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
